import React from 'react'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import stripTimeZone from 'utils/stripTimeZone'

import { BlogPostQuery } from '../types/query'

type Props = {
  blogPost: NonNullable<BlogPostQuery['blogPost']>
}

const HeroSection = ({ blogPost }: Props) => {
  return (
    <main className="lg:relative w-full bg-gray-100">
      <div className="mx-auto max-w-7xl w-full pt-8 pb-6 text-center lg:text-left px-4 sm:px-6 lg:px-8">
        <span className="italic text-gray-600 text-sm mb-2 block">
          {format(parseISO(stripTimeZone(blogPost.publishedAt)), 'd MMMM y')}
        </span>
        <h1 className="text-4xl tracking-tight font-extrabold text-gray-900">
          {blogPost.title}
        </h1>
      </div>
    </main>
  )
}

export default HeroSection
